module.exports = __webpack_public_path__ + "img/numeralia_cedis_51.a240bd98.webp";